import axiosClient from "../utils/axios";

export default function ({ collectionAddress, itemId }: {
  collectionAddress: string,
  itemId: any
}) {
  return axiosClient
    .get(`/items/single`, {
      params: {
        collectionAddress,
        itemId
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return Promise.reject(error);
    });
}
